// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45734acb","239":"0d2f2a3b","453":"a4cd9be4","455":"56ac38e3"}[chunkId] + ".chunk.js";
};